<template>
  <div>
    <el-dialog
      v-if="visible"
      width="780px"
      :title="$l('dialog_title_editFabric') || '编辑面料'"
      visible
      show-close
      append-to-body
      :before-close="() => cancel()"
      v-el-dialog-drag
    >
      <el-tabs v-model="formData.isFabricPosition">
        <el-tab-pane
          :label="$l('tabs_label_isFabricPosition_y') || '按面料位置'"
          name="Y"
        />
        <el-tab-pane
          :label="$l('tabs_label_isFabricPosition_n') || '不区分位置'"
          name="N"
        />
      </el-tabs>

      <el-form
        ref="form"
        size="mini"
        :model="formData"
        :rules="rules"
        label-position="left"
        label-width="80px"
        inline-message
      >
        <el-row v-if="formData.isFabricPosition == 'Y'">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_faceFabric') || '正面'"
              :inline-message="false"
              prop="faceFabric"
            >
              <el-input
                v-model="formData.faceFabric"
                :placeholder="$l('form_placeholder_faceFabric')"
                :maxlength="120"
                clearable
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_innerFabric') || '填充'"
              :inline-message="false"
              prop="innerFabric"
            >
              <el-input
                v-model="formData.innerFabric"
                :placeholder="$l('form_placeholder_innerFabric')"
                :maxlength="120"
                clearable
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_backFabric') || '反面'"
              prop="backFabric"
            >
              <el-input
                v-model="formData.backFabric"
                :placeholder="$l('form_placeholder_backFabric')"
                :maxlength="120"
                clearable
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-else>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_displayFabric') || '展品面料'"
              prop="faceFabric"
            >
              <el-input
                v-model="formData.faceFabric"
                :placeholder="$l('form_placeholder_allFabric')"
                :maxlength="200"
                :rows="5"
                clearable
                show-word-limit
                type="textarea"
                class="mr-1"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    visible: { type: Boolean, default: false },
    isFabricPosition: { type: String, default: 'Y' },
    faceFabric: { type: String, default: '' },
    backFabric: { type: String, default: '' },
    innerFabric: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        isFabricPosition: '',
        faceFabric: '',
        backFabric: '',
        innerFabric: '',
      },
    }
  },
  computed: {
    form() {
      return {
        isFabricPosition: this.isFabricPosition || 'Y',
        faceFabric: this.faceFabric,
        backFabric: this.backFabric,
        innerFabric: this.innerFabric,
      }
    },
    displayFabric() {
      return [
        this.formData.faceFabric,
        this.formData.backFabric,
        this.formData.innerFabric,
      ]
        .filter(Boolean)
        .join('')
        .trim()
    },
    rules() {
      return {
        faceFabric: [
          {
            trigger: 'blur',
            required:
              this.formData.isFabricPosition === 'N'
                ? true
                : !this.displayFabric,
            message:
              this.formData.isFabricPosition === 'N'
                ? this.$l('INDEX.tips_input_placeholder') || '请输入...'
                : ' ',
          },
          {
            validator: (rule, value, callback) => {
              if (this.formData.isFabricPosition === 'Y') {
                const length = value?.length
                if (length > 120) {
                  return callback(new Error(' '))
                }
              }
              const values = value?.split('\n\n') || []
              if (values.length > 3) {
                return callback(
                  new Error(
                    this.$l('tips_input_emptyline') || '最多允许输入两个空行'
                  )
                )
              }
              callback()
            },
          },
        ],
        innerFabric: [
          {
            trigger: 'blur',
            required:
              this.formData.isFabricPosition === 'Y' && !this.displayFabric,
            message: ' ',
          },
        ],
        backFabric: [
          {
            trigger: 'blur',
            required:
              this.formData.isFabricPosition === 'Y' && !this.displayFabric,
            message:
              this.$l('form_placeholder_fabric') ||
              '请填写正面、反面、填充其中一项面料信息',
          },
        ],
      }
    },
  },
  watch: {
    form: {
      handler(data) {
        this.formData = { ...(data || {}) }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.$emit('confirm', this.formData)
      this.close()
    },
    async cancel() {
      const confirm = await this.$confirm(
        this.$l('confirm_saveFabric') || '是否要保存面料信息？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return this.close()
      this.confirm()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.formData = { ...(this.form || {}) }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-tabs__nav-wrap::after {
    content: none !important;
  }
}
</style>
